export default __webpack_public_path__ + "img/men.5ee11a43.png";